import type {YAxisOptions} from 'highcharts';
import {CubeMeasure} from '../types';

const isPercent = (measure: CubeMeasure): boolean => measure.metric === 'share' || measure.unit === '%';

/**
 * Caps a percent axis at 100 %: the Highcharts padding plus endOnTick would otherwise stretch it to the next tick (125/150 %).
 * The minimum stays automatic so a line or dumbbell does not flatten a small change (95 -> 99 %).
 * Nothing is capped when any plotted measure is not a percentage or any value exceeds 100.
 */
export function percentAxisCap(measures: CubeMeasure[], values: Array<number | null | undefined>): Partial<YAxisOptions> {
    if (measures.length === 0 || !measures.every(isPercent)) {
        return {};
    }
    const numbers = values.filter((v): v is number => typeof v === 'number');
    if (numbers.length === 0 || numbers.some(v => v > 100)) {
        return {};
    }
    return {max: 100, endOnTick: false};
}
